import Title from 'app/ui/display/Title';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudRotateScreen extends Phaser.Group {
  constructor({ game }) {
    super(game);

    this.game = game;

    this.background = this.game.make.sprite(0, 0, 'rotate', 'rotate_screen_bg.jpg');
    this.background.inputEnabled = true;
    this.add(this.background);

    this.iconNo = this.game.make.sprite(0, 0, 'rotate', 'icon_no.png');
    this.iconNo.anchor.set(0.5);
    this.iconNo.scale.set(0.5);
    this.add(this.iconNo);

    this.iconRotate = this.game.make.sprite(0, 0, 'rotate', 'icon_rotate.png');
    this.iconRotate.anchor.set(0.5, 0);
    this.iconRotate.scale.set(0.5);
    this.add(this.iconRotate);

    this.iconYes = this.game.make.sprite(0, 0, 'rotate', 'icon_yes.png');
    this.iconYes.anchor.set(0.5);
    this.iconYes.scale.set(0.5);
    this.add(this.iconYes);

    this.apple = this.game.make.sprite(0, 0, 'rotate', 'rotate_apple.png');
    this.apple.anchor.set(1, 0.5);
    this.apple.scale.set(0.5);
    this.add(this.apple);

    this.onion = this.game.make.sprite(0, 0, 'rotate', 'rotate_onion.png');
    this.onion.anchor.set(0, 0.5);
    this.onion.scale.set(0.5);
    this.add(this.onion);

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.handleScreenResize();
  }

  handleScreenResize() {
    // this.container.x = this.game.width * 0.5 - this.background.width;
    // this.container.y = this.game.height * 0.5 - this.background.height;

    this.iconNo.position.set(this.game.width * 0.5, this.game.height * 0.25);
    this.iconRotate.position.set(this.game.width * 0.5, this.game.height * 0.5);
    this.iconYes.position.set(this.game.width * 0.5, this.game.height * 0.75);

    this.apple.position.set(this.game.width, this.game.height * 0.25);
    this.onion.position.set(0, this.game.height * 0.6);

    this.background.width = this.game.width;
    this.background.height = this.game.height;
  }

  get height() {
    return this.background.height;
  }

  get width() {
    return this.background.width;
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    this.background.destroy(true);

    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);

    // // nullify
    this.background = null;
    // // super dupa
    super.destroy(true);
  }
}
